import { z } from 'zod';

export const DsSubCheckSchema = z.object({
  name: z.string(),
  passed: z.union([z.boolean(), z.null()]),
  inner_weight: z.number(),
  applicable: z.boolean(),
  detail: z.string().optional(),
});

export const DsFeatureSchema = z.object({
  name: z.string(),
  weight: z.number(),
  is_scored: z.boolean(),
  feature_score: z.union([z.number().min(0).max(1), z.null()]),
  sub_checks: z.array(DsSubCheckSchema).optional().default([]),
});

const upperEnum = <T extends [string, ...string[]]>(values: T) =>
  z.preprocess((v) => (typeof v === 'string' ? v.toUpperCase() : v), z.enum(values));

export const DsAssetResultSchema = z.object({
  url: z.string(),
  asset_type: upperEnum(['IMAGE', 'VIDEO']),
  platform: upperEnum(['META', 'YOUTUBE', 'SNAPCHAT', 'TIKTOK', 'DV360', 'ADFORM']),
  placement: z.string(),
  score: z.union([z.number().min(0).max(100), z.null()]),
  error: z.string().nullable(),
  features: z.array(DsFeatureSchema),
});

export type DsSubCheck = z.infer<typeof DsSubCheckSchema>;
export type DsFeature = z.infer<typeof DsFeatureSchema>;
export type DsAssetResult = z.infer<typeof DsAssetResultSchema>;
